import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { useSite } from '../SiteContext';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  useSite();
  const isHome = location.pathname === '/';

  const goTo = (item) => {
    setIsMenuOpen(false);
    if (item.route) {
      navigate(item.route);
      return;
    }
    if (item.id) {
      // If we're on home, scroll. Otherwise go home + hash so the section is reachable.
      if (isHome) {
        const el = document.getElementById(item.id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        navigate(`/#${item.id}`);
      }
    }
  };

  const menuItems = [
    { label: 'Blog/Artikel', route: '/blog' },
    { label: 'Kalkulator', id: 'calculator' },
    { label: 'Trading Journal', route: '/trading-journal' },
    { label: 'Halaman Utama', id: 'hero', homeRoute: true },
    { label: 'Tentang Kami', id: 'about' },
    { label: 'Kelas', id: 'classes' },
    { label: 'Testimoni', id: 'testimonials' },
    { label: 'Hubungi', id: 'contact' },
  ];

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md shadow-sm">
      <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0 cursor-pointer -ml-4" onClick={() => navigate('/')}>
            <img
              src="https://customer-assets.emergentagent.com/job_syariah-saham/artifacts/2tpjykxz_Logo%20Official%20Maahad%20Bursaa%20%20%282%29.png"
              alt="Maahad Bursa"
              className="h-40 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {menuItems.map((item) => (
              <button
                key={item.label}
                onClick={() => goTo(item)}
                className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-[#1ec7a0] transition-colors duration-200 rounded-lg hover:bg-gray-50"
                data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* CTA Button Desktop */}
          <div className="hidden lg:block">
            <Button
              onClick={() => goTo({ id: 'classes' })}
              className="btn-primary px-6 py-2 rounded-lg font-semibold"
              style={{ backgroundColor: '#1ec7a0' }}
            >
              Daftar Sekarang
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 animate-fadeIn">
            <div className="flex flex-col space-y-2">
              {menuItems.map((item) => (
                <button
                  key={item.label}
                  onClick={() => goTo(item)}
                  className="px-4 py-3 text-left text-sm font-medium text-gray-700 hover:text-[#1ec7a0] hover:bg-gray-50 rounded-lg transition-colors"
                  data-testid={`mobile-nav-${item.label.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
                >
                  {item.label}
                </button>
              ))}
              <Button
                onClick={() => goTo({ id: 'classes' })}
                className="btn-primary w-full mt-4 py-3 rounded-lg font-semibold"
                style={{ backgroundColor: '#1ec7a0' }}
              >
                Daftar Sekarang
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;